import usePrivateAxios from '@/common/api/usePrivateAxios';
import { ErrorResponse } from '@/common/types/errorResponse';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { DASHBOARD_COMPONENT_DEFAULT_HEIGHT, DASHBOARD_COMPONENT_DEFAULT_WIDTH } from '../../constants/dashboards/dashboardGridConfig.constant';
import { CreateDashboardComponentValidationSchema } from '../../schemas/dashboards/dashboardComponent';

interface UseCreateDashboardComponentProps {
  dashboardId: string | undefined;
  initialPosition: {
    x: number;
    y: number;
  };
  options?: Partial<Omit<UseMutationOptions<
    unknown,
    ErrorResponse,
    CreateDashboardComponentValidationSchema
  >, 'mutationKey' | 'mutationFn'>>;
}

export const useCreateDashboardComponent = ({
  dashboardId,
  initialPosition,
  options,
}: UseCreateDashboardComponentProps) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['createDashboardComponent', dashboardId],
    mutationFn: (form) => {
      return privateAxios.put(`/dashboards/${dashboardId}`, {
        dashboard: {
          components_attributes: [
            {
              generator_klass: form.generator_klass?.value,
              generator_properties: {
                kind: form?.kind?.value,
              },
              start_x: initialPosition.x,
              start_y: initialPosition.y,
              width: DASHBOARD_COMPONENT_DEFAULT_WIDTH,
              height: DASHBOARD_COMPONENT_DEFAULT_HEIGHT,
            },
          ],
        },
      });
    },
    ...options,
  });
}
